// extracted by mini-css-extract-plugin
export default {"wrapper":"NewUserHintModal_wrapper__6IH96","title":"NewUserHintModal_title__3c1sV","actionButtons":"NewUserHintModal_actionButtons__lxHyf"};